import GetLocation from 'react-native-get-location';

type Location = {
  latitude: number;
  longitude: number;
} | null;

export const getUserLocation = async (
  enableHighAccuracy: boolean = false
): Promise<Location> => {
  try {
    const { latitude, longitude } = await GetLocation.getCurrentPosition({
      enableHighAccuracy,
      timeout: 20000,
    });

    return { latitude, longitude };
  } catch (e) {
    console.warn(e);
    return null;
  }
};
